import React, { useState } from 'react';
import { View, StyleSheet, Platform, FlatList } from 'react-native';
import { scaleSize } from '~/constants/scale';
import { useStyles } from '~/hooks';
import { FONT_SIZE_S, FONT_SIZE_XS } from '~/constants/typography';
import CashRow from './CashRow';
import { useCash } from '~/hooks/useCash';
import FromToSelector from '../Result/FromToSelector';
import DateRow, { getDateRow } from '../Result/DateRow';
import { Theme } from '~/theme';
import { Text } from '~/components/core';
import Loader from '~/components/core/Loader';
import ReportExportBar from '../Reports/ReportExportBar';
import { useCsvExportEnabled, useCashCsvExport } from '~/hooks';

const now = new Date();
const prevPeriod = new Date(now.getTime() - 7 * 24 * 3600 * 1000);
prevPeriod.setHours(0);
prevPeriod.setMinutes(0);
prevPeriod.setSeconds(0);

export default function Cash() {
    const [fromButton, setFromButton] = useState(prevPeriod);
    const [toButton, setToButton] = useState(now);
    const { cashArray, totalDirection, totalFormatted, loading, onEndReached, reportSpec } = useCash(
        fromButton,
        toButton
    );
    const styles = useStyles(stylesGenerator);
    const exportEnabled = useCsvExportEnabled();
    const csvExport = useCashCsvExport(reportSpec);

    return (
        <>
            <Loader loading={loading} />
            {exportEnabled ? (
                <ReportExportBar
                    state={csvExport.state}
                    rowsFetched={csvExport.rowsFetched}
                    onExport={csvExport.start}
                    onCancel={csvExport.cancel}
                />
            ) : null}
            <View style={styles.cashHeaderContainer}>
                <Text style={styles.cashHeaderText} fontType="LATO_BOLD">
                    details-label
                </Text>
                <Text style={styles.cashHeaderText} fontType="LATO_BOLD">
                    time-label
                </Text>
                <Text style={styles.cashHeaderText} fontType="LATO_BOLD">
                    amount-label
                </Text>
            </View>
            <FlatList
                style={styles.ordersContainer}
                data={cashArray}
                renderItem={({ item, index }) => (
                    <View style={styles.button} key={index}>
                        {getDateRow(item.timestamp, index) !== '' ? <DateRow timestamp={item.timestamp} /> : null}
                        <CashRow cash={item} />
                    </View>
                )}
                keyExtractor={(item) => item.id}
                key={'cash'}
                initialNumToRender={20}
                onEndReachedThreshold={0.4}
                onEndReached={onEndReached}
            />
            <FromToSelector
                setFromButton={setFromButton}
                setToButton={setToButton}
                prevPeriod={prevPeriod}
                totalFormatted={totalFormatted}
                totalDirection={totalDirection}
            />
        </>
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        cashHeaderText: { fontSize: FONT_SIZE_XS, color: theme.card },
        cashHeaderContainer: {
            flexDirection: 'row',
            width: '100%',
            height: scaleSize(30),
            backgroundColor: theme.background_positionId,
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingHorizontal: scaleSize(30),
        },
        ordersContainer: {
            paddingTop: scaleSize(7),
            paddingLeft: scaleSize(7),
            paddingRight: Platform.OS === 'web' ? 0 : scaleSize(7),
        },
        button: { width: '100%' },
        datePickerContainer: {
            flexDirection: 'row',
        },
        datePickerItem: {
            flex: 1,
            padding: scaleSize(5),
        },
        datePickerLabel: {
            fontSize: FONT_SIZE_S,
        },
    });
